import * as Sentry from "@sentry/react";
import { LogErrors } from "./LogErrors";

// Fetch a single band by BandID
export const fetchBand = async (BandID, token) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}Bands/FetchBand?bandid=${BandID}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorMsg = `Failed to fetch band. Status: ${response.status} - ${response.statusText}`;
      Sentry.captureMessage(errorMsg, "error");
      // LogErrors(user, logout, updateTokens, errorMsg);
      return null;
    }

    return await response.json();

  } catch (error) {
    // LogErrors(user, logout, updateTokens, "Error fetching band:", error);
    Sentry.captureException(error);
    return null;
  }
};